import React, { FunctionComponent } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTheme } from 'styled-components';
import {
  Container,
  Icon,
  Text,
  Title,
  Description,
  Content,
  ContainerButtons,
  BackgroundColorType,
} from './styles';
import { ReducerContract } from '../../store/ducks';
import { Actions, OptionsContract } from '../../store/ducks/modal';
import Button from '../../components/Button';

export interface Props {
  icon: any;
  title: string;
  description: string;
  buttonDescription: string;
  open?: boolean;
  backgroundColor?: BackgroundColorType;
  buttonPrimaryDescription?: string;
  buttonPrimaryAction?: any;
  loading?: boolean;
  timerAction?: any;
}

export const useAlert = () => {
  const dispatch = useDispatch();

  function close() {
    dispatch(Actions.close());
  }

  function alert(options: OptionsContract) {
    dispatch(Actions.open(options));
  }

  function setLoading(value: boolean) {
    dispatch(Actions.setLoading(value));
  }

  function setTitle(value: string) {
    dispatch(Actions.setTitle(value));
  }

  return { close, alert, setLoading, setTitle };
};

const Alert: FunctionComponent = () => {
  const {
    open,
    backgroundColor,
    title,
    icon,
    description,
    buttonDescription,
    buttonPrimaryDescription,
    buttonPrimaryAction,
    loading,
    timerAction,
  } = useSelector<ReducerContract, Props>(state => state.Modal);
  const dispatch = useDispatch();

  const theme = useTheme();

  function close() {
    dispatch(Actions.close());
  }

  if (timerAction) {
    setTimeout(() => {
      timerAction();
    }, 1000);
  }

  return (
    <Container open={open} backgroundColor={backgroundColor}>
      <Content>
        <Icon src={icon} />
        {timerAction ? (
          <Title data-cy='modal-title'>
            {title.split(' ').map(item => (
              <Text
                style={{
                  color: item.match('[0-9][0-9]:[0-9][0-9]:[0-9][0-9]')
                    ? theme.color.primary
                    : theme.color.neutral,
                }}
                key={title.indexOf(item)}
              >
                {item}{' '}
              </Text>
            ))}
          </Title>
        ) : (
          <Title data-cy='modal-title'>{title}</Title>
        )}

        <Description data-cy='modal-description'>{description}</Description>

        {backgroundColor === 'PRIMARY' ? (
          <ContainerButtons>
            {!loading && (
              <Button data-cy='modal-button' theme="LINK" onClick={close}>
                {buttonDescription}
              </Button>
            )}
            <Button
              data-cy='modal-button-primary'
              theme="LINK_PRIMARY"
              loading={loading}
              onClick={buttonPrimaryAction}
            >
              {buttonPrimaryDescription}
            </Button>
          </ContainerButtons>
        ) : (
          <Button data-cy='modal-button-description' theme="MINIMAL" onClick={close}>
            {buttonDescription}
          </Button>
        )}
      </Content>
    </Container>
  );
};

export default Alert;
